<span class="breadcrumbs flex-row flex-align-center">
  <ng-container *ngIf="!loading; else loadingTpl">
    <ng-container *ngFor="let item of items">
      <a
        *ngIf="item.routerLink"
        [routerLink]="item.routerLink"
        [queryParams]="item.queryParams ?? null"
        [state]="item.state ?? {}"
      >
        {{ item.translate !== false ? (item.label | translate) : item.label }}
      </a>
      <span *ngIf="!item.routerLink">
        {{ item.translate !== false ? (item.label | translate) : item.label }}
      </span>
    </ng-container>
  </ng-container>
  <ng-template #loadingTpl>
    <span class="loading-dots">...</span>
  </ng-template>
</span>
